import { Banner, Typography } from "@reconvert/react-ui-component";
import { Box, Button, Flex } from "@chakra-ui/react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { selectAppState } from "../../app/slice/appSlice";
import { Slot, SlotStatus } from "../../models";
import { updateSlotStatusAsync } from "../../app/slice/slotSlice";
import { useTranslation } from "react-i18next";
const bannerType = "warning";

const SlotPublishWarning = ({ slot }: { slot: Slot }) => {
  const { t } = useTranslation();
  const { storeInfo } = useAppSelector(selectAppState);
  const dispatch = useAppDispatch();
  const handleEditorRedirect = () => {
    const editorUrl = `https://manage.wix.com/editor/${storeInfo?.siteId}`;

    window.open(editorUrl, "_blank");
  };

  const handlePublishUpdates = async () => {
    const payload = {
      slotNo: slot.slotNo,
      location: "PRE_PURCHASE_PRODUCT_PAGE",
      updateStatus: SlotStatus.ACTIVE,
    };

    await dispatch(updateSlotStatusAsync({ id: slot.id, body: payload }));
  };

  return (
    <Box mx={"16px"} mt={3} p={2}>
      <Banner
        title={t("It seems like you didn't publish the updates on your store")}
        status={"warning" as any}
        description={
          <Flex gap="8px" direction="column" align="flex-start" overflow="hidden">
            <Typography variant="body-14-regular" color="warning.900" textOverflow="ellipsis" overflow="hidden">
              {t(
                `Without visiting the product page on the editor and publishing your store's product page the upsell widget will not be shown. Please go to Wix Editor (product page) and publish the changes to your store`,
              )}
            </Typography>
            <Flex gap="8px" direction="row" align="center" overflow="hidden" flexWrap="wrap">
              <Button
                variant="primary"
                onClick={handleEditorRedirect}
              >
                {t("Go to Wix Editor and publish the updates")}
              </Button>
              <Button
                variant="plain"
                onClick={handlePublishUpdates}
              >
                {t("I already published the updates")}
              </Button>
            </Flex>
          </Flex>
        }
      />
    </Box>
  );
};

export default SlotPublishWarning;
